import { FORM_PATHS, openInModalOrPage } from '../../modals';
import { createFakeId } from '../../../reducers/util';

export const CREATE_MEETING_TYPE_MEETING = 'Meeting';

export const createMeeting = companyId => (dispatch, getState) =>
    dispatch(openInModalOrPage(FORM_PATHS.EditMeetingModal, createFakeId(), {}, companyId));
